import * as Yup from 'yup'

export const TicketFormValidation = Yup.object({
    raisedAt: Yup.string().required("Date is required!"),
    title: Yup.string().required("Title is required!"),
    description: Yup.string().required("Description is required!"),
    status: Yup.string().required("Status is required!"),
    raisedById: Yup.number().required("Username is required!"),
})